module.exports = __webpack_public_path__ + "15bd9ba588e565c37c097fe23e41e7de.svg";